import LeadFormEdit from '@/Pages/Form/LeadFormEdit'
import { RootState } from '@/Store'
import { Button, HStack, Typography, VStack, XelaColor } from '@/XelaReact'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import LeadForm = App.Models.LeadForm

const AgentLeadView: FC<{ leadForm: LeadForm; csrfToken: string }> = ({ leadForm, csrfToken }) => {
  const leadFormStore = useSelector((state: RootState) => state.leadForm)
  const [showLeadFormEdit, setShowLeadFormEdit] = useState(false)

  if (!showLeadFormEdit) {
    return (
      <VStack
        spacing="24px"
        width="auto"
        bg={XelaColor.White}
        borderRadius="16px"
        style={{
          padding: '24px',
          margin: '24px',
          minWidth: '350px',
        }}
        alignItems="center"
      >
        <VStack alignItems="center" spacing="8px">
          <Typography variant="headline">Welcome Back!</Typography>
          <VStack alignItems="center" spacing="12px">
            <VStack alignItems="center">
              <HStack justifyContent="center">
                {leadFormStore.lead && (
                  <Typography color={XelaColor.Blue3} variant="subheadline">
                    {leadFormStore.lead.name}
                  </Typography>
                )}
              </HStack>
              <Typography color={XelaColor.Gray6} variant="body-small">
                {leadFormStore.lead ? leadFormStore.lead.country_calling_code + leadFormStore.lead.phone : ''}
              </Typography>
            </VStack>
            {leadFormStore.lead && !leadFormStore.lead.is_profile_locked && (
              <Button
                variant="secondary"
                size={'small'}
                label={'Edit Profile'}
                onClick={() => setShowLeadFormEdit(true)}
              >
                Edit Profile
              </Button>
            )}
          </VStack>
        </VStack>

        {leadFormStore.lead && leadFormStore.lead.agent && (
          <HStack
            spacing="8px"
            justifyContent="space-between"
            bg={XelaColor.Blue12}
            style={{ padding: '16px', borderRadius: '16px' }}
          >
            <VStack>
              <Typography color={XelaColor.Gray3} variant="body-small-bold">
                {leadFormStore.lead.agent?.name}
              </Typography>
              <Typography color={XelaColor.Gray6} variant="caption">
                {leadFormStore.lead.agent?.phone}
              </Typography>
            </VStack>
            <VStack spacing="4px" alignItems="center">
              <Typography
                color={XelaColor.Blue3}
                variant="body-small-bold"
                style={{
                  padding: '4px 8px',
                  borderRadius: '8px',
                  backgroundColor: XelaColor.Blue10,
                }}
              >
                Assigned Agent
              </Typography>
              <Typography color={XelaColor.Gray3} variant="caption" align={'center'}>
                Agency : {leadFormStore.lead.agent?.agency_name}
              </Typography>
            </VStack>
          </HStack>
        )}
        {leadFormStore.lead && leadFormStore.lead.agent && (
          <HStack spacing="8px" justifyContent="center">
            <Typography color={XelaColor.Gray6} variant="caption-bold">
              Please Coordinate With Your Assigned Agent
            </Typography>
          </HStack>
        )}
        {leadFormStore.lead && leadFormStore.lead.agent == null && (
          <HStack spacing="8px" justifyContent="center">
            <Typography color={XelaColor.Gray6} variant="caption-bold">
              Please coordinate with the front desk
            </Typography>
          </HStack>
        )}
      </VStack>
    )
  }

  return <LeadFormEdit leadForm={leadForm} csrfToken={csrfToken} />
}

export default AgentLeadView
